import React from "react";
import "../OrderDetailsAllDoc/AllDoc.css";

const VaccinationModal = ({ closeModal }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={closeModal}>
          ✖
        </button>
        <header className="vaccination-header">
          <h2 className="vaccinationh1">Vaccination Book</h2>

          <div className="document-info">
            <div className="row document-info-row">
              <div className="col-3"><p style={{  fontSize: '11px' }}>
                <strong style={{paddingRight: '36px'}}>Label ID</strong> : 1224
              </p></div>
              <div className="col-3"><p style={{  fontSize: '11px' }}>
                <strong style={{paddingRight: '13px'}}>Customer Name</strong>: Vacant Mulligan
              </p></div>
              <div className="col-3"><p style={{  fontSize: '11px' }}>
                <strong style={{paddingRight: '10px'}}>Time of Upload</strong>: 07:45 PM
              </p></div>
             
              
            
            </div>

            <div className="row document-info-row">
              <div className="col-3"><p style={{  fontSize: '11px' }}>
                <strong>Date of Upload</strong> : 13 Dec 2024
              </p></div>
              <div className="col-3"><p style={{  fontSize: '11px' }}>
                <strong style={{paddingRight: '6px'}}>Sales Coordinator</strong>: VName Here
              </p></div>
              <div className="col-3"><p style={{  fontSize: '11px' }}>
                <strong>Ops Coordinator</strong> :  Name Here
              </p></div>
              
            
            </div>

           
            <div
              style={{
                position: "absolute",
                top: "93px",
                left: "44rem",
                height: "52px",
                border: "1px solid #DEE2E6",
                width: "0px",
              }}
            ></div>
            <div
              className="document-info-actions"
              style={{ textAlign: "right" }}
            >
              <button
                className="delete-button"
                style={{
                  position: "relative",
                  top: "-62px",
                  width: "7rem",
                  fontSize: "14px",
                  height: "3rem",
                  backgroundColor: "white",
                  color: "red",
                  border: "1px solid red",
                }}
              >
                <i className="fas fa-trash-alt"></i> Delete
              </button>
              <button
                className="download-button"
                style={{
                  position: "relative",
                  top: "-62px",
                  width: "7rem",
                  fontSize: "14px",
                  height: "3rem",
                  backgroundColor: "white",
                  color: "black",
                  border: "1px solid rgb(222, 226, 230)",
                }}
              >
                <i className="fas fa-download"></i> Download
              </button>
            </div>
          </div>
        </header>
        <div
          className="container"
          style={{ backgroundColor: "#F8F9FA", padding: "12px" }}
        >
          <section className="owner-details">
            <h3 style={{ fontSize: "18px", fontWeight: '600',borderBottom: '1px solid gray' }}>Pet Owner's Details</h3>
            <hr style={{
    margin:'0px',
    position: 'relative',
    top: '-9px',
    width: '163px',
    height: '3px',
    background: '#5B489D',
    opacity: '1'
}}></hr>
            <div
              className="row vaccinationdoc_Pet"
              style={{ display: "flex"}}
            >
              <div className="col-3">
              <p style={{ display: "flex", flexDirection: "column", fontSize: '11px' }}>
                <strong>Full Name:</strong> Shakuntala Mulligan
              </p>
              </div>
              <div className="col-3"> <p style={{ display: "flex", flexDirection: "column", fontSize: '11px' }}>
                <strong>Contact Number:</strong> +91 9999999999
              </p></div>
              <div className="col-3"><p style={{ display: "flex", flexDirection: "column", fontSize: '11px' }}>
                <strong>Email:</strong> example@example.com
              </p></div>
              <div className="col-3"><p style={{ display: "flex", flexDirection: "column", fontSize: '11px' }}>
                <strong>Address:</strong> Cargo Mega Terminal, Cargo Village,
                Delhi
              </p></div>
              
             
              
              
            </div>
          </section>

          <section className="pet-details">
            <h3 style={{ fontSize: "18px", fontWeight: '600',borderBottom: '1px solid gray' }}>Pet's Details</h3>
            <hr style={{
    margin:'0px',
    position: 'relative',
    top: '-9px',
    width: '163px',
    height: '3px',
    background: '#5B489D',
    opacity: '1'
}}></hr>
            <div
              className="row vaccinationdoc_Pet"
              style={{ display: "flex"}}
            >
                <div className="col-3"><p style={{ display: "flex", flexDirection: "column", fontSize: '11px' }}>
                <strong>Name:</strong> GOGO
              </p></div>
              <div className="col-3"> <p style={{ display: "flex", flexDirection: "column", fontSize: '11px' }}>
                <strong>Date of Birth:</strong> 20 Dec 2021
              </p></div>
              <div className="col-3"> <p style={{ display: "flex", flexDirection: "column", fontSize: '11px' }}>
                <strong>Gender:</strong> Male
              </p></div>
              <div className="col-3"> <p style={{ display: "flex", flexDirection: "column", fontSize: '11px' }}>
                <strong>Color:</strong> Black
              </p></div>
            
             </div>
             <div
              className="row vaccinationdoc_Pet"
              style={{ display: "flex"}}
            >
             <div className="col-3">
             <p style={{ display: "flex", flexDirection: "column", fontSize: '11px' }}>
                <strong>Breed:</strong> Labrador
              </p>
             </div>
             <div className="col-3">
             <p style={{ display: "flex", flexDirection: "column", fontSize: '11px' }}>
                <strong>Microchip Number:</strong> 123456789
              </p>
             </div>
              
              
            </div>
          </section>
        </div>

        <section className="verification-section">
          <form>
            <div className="checklist-item" style={{ maxWidth: "63%" }}>
              <label>
                1. Please verify the pet owner's details according to the
                checklist provided.
              </label>
              <table>
                <thead>
                  <tr>
                    <th
                      style={{
                        border: "none",
                        fontSize: "12px",
                        background: "revert",
                      }}
                    >
                      Pet Owner Details
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        fontSize: "12px",
                        background: "revert",
                      }}
                    >
                      Matches
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        fontSize: "12px",
                        background: "revert",
                      }}
                    >
                      Does Not Match
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        fontSize: "12px",
                        background: "revert",
                      }}
                    >
                      Does Not Match
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ fontSize: "12px",paddingBottom: '0',paddingTop: '0' }}>1.Pet Owner Name</td>
                    <td style={{ fontSize: "12px", textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ fontSize: "12px", textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ fontSize: "12px", textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "12px",paddingBottom: '0',paddingTop: '0' }}>2.Contact Number</td>
                    <td style={{ fontSize: "12px", textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ fontSize: "12px", textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ fontSize: "12px", textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "12px",paddingBottom: '0',paddingTop: '0' }}>3.Email ID</td>
                    <td style={{ fontSize: "12px", textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ fontSize: "12px", textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ fontSize: "12px", textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "12px",paddingBottom: '0',paddingTop: '0' }}>4.Address</td>
                    <td style={{ fontSize: "12px", textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ fontSize: "12px", textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ fontSize: "12px", textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                
                </tbody>
              </table>
              <br></br>
              <label>
                2. Please verify the pet's details according to the checklist
                provided.
              </label>
              <table>
                <thead>
                  <tr>
                    <th
                      style={{
                        border: "none",
                        fontSize: "12px",
                        background: "revert",
                      }}
                    >
                      Pet Details
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        fontSize: "12px",
                        background: "revert",
                      }}
                    >
                      Matches
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        fontSize: "12px",
                        background: "revert",
                      }}
                    >
                      Does Not Match
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        fontSize: "12px",
                        background: "revert",
                      }}
                    >
                      Does Not Match
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ fontSize: "12px",paddingBottom: '0',paddingTop: '0' }}>1.Name</td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "12px",paddingBottom: '0',paddingTop: '0' }}>2.DOB</td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "12px",paddingBottom: '0',paddingTop: '0' }}>3.Gender</td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "12px",paddingBottom: '0',paddingTop: '0' }}>4.Colour</td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "12px",paddingBottom: '0',paddingTop: '0' }}>5.Breed</td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "12px",paddingBottom: '0',paddingTop: '0' }}>6.Microchip Number</td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                </tbody>
              </table>

              <br></br>
              <label>
                3. Please verify the vaccination details according to the
                checklist provided.
              </label>
              <h3
                style={{
                  fontSize: "13px",
                  fontWeight: "600",
                  padding: "9px 0 0 18px",
                }}
              >
                Mandatory Vaccinations
                <span style={{ fontSize: "12px", fontWeight: "200" }}>
                  (It should be valid and endorsed with a veterinarian's stamp
                  and signature)
                </span>
              </h3>
              <table>
                <thead>
                  <tr>
                    <th
                      style={{
                        border: "none",
                        fontSize: "12px",
                        background: "revert",
                      }}
                    >
                      1. Dog
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        fontSize: "12px",
                        background: "revert",
                      }}
                    >
                      Matches
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        fontSize: "12px",
                        background: "revert",
                      }}
                    >
                      Does Not Match
                    </th>
                    <th
                      style={{
                        border: "none",
                        textAlign: "center",
                        fontSize: "12px",
                        background: "revert",
                      }}
                    >
                      Does Not Match
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ fontSize: "12px", paddingLeft: "25px",paddingBottom: '0',paddingTop: '0' }}>
                      .DHPPIL
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "12px", paddingLeft: "25px",paddingBottom: '0',paddingTop: '0' }}>
                      .Rabies
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                  <tr>
                    <th
                      style={{
                        fontSize: "12px",
                        background: "revert",
                        border: "none",
                      }}
                    >
                      2.cat
                    </th>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "12px", paddingLeft: "25px",paddingBottom: '0',paddingTop: '0' }}>
                      .FVRCP
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "12px", paddingLeft: "25px",paddingBottom: '0',paddingTop: '0' }}>
                      .Rabies
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                    <td style={{ textAlign: "center",paddingBottom: '0',paddingTop: '0' }}>
                      <input type="checkbox" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

           
           
          </form>
        </section>

        <div
          className="container"
          style={{ backgroundColor: "#F8F9FA", padding: "12px" }}
        >
          <section className="owner-details">
            <h3 style={{ fontSize: "18px", fontWeight: '600' }}>
              Is the following document verified to be correct & approved for
              pet travel?{" "}
            </h3>
            <span>
              Documentation must be completed approved before any travel
              planning.{" "}
            </span>
            <div
              className="vaccinationdoc_Pet"
              style={{ display: "flex", gap: "100px" }}
            >
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  style={{
                    appearance: "none", // Removes default checkbox styling
                    width: "11px",
                    height: "14px",
                    borderRadius: "50%", // Makes the checkbox circular
                    border: "1px solid gray", // Adds border
                    outline: "none", // Removes focus outline
                    cursor: "pointer",
                    transition: "background-color 0.2s ease",
                  }}
                  onChange={(e) => {
                    // Dynamically toggle the background color
                    e.target.style.backgroundColor = e.target.checked
                      ? "#4caf50"
                      : "transparent";
                    e.target.style.borderColor = e.target.checked
                      ? "#4caf50"
                      : "#000";
                  }}
                />
                <span style={{ marginLeft: "8px", fontSize: "16px" }}>
                  Verified
                </span>
              </div>

              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  style={{
                    appearance: "none", // Removes default checkbox styling
                    width: "11px",
                    height: "14px",
                    borderRadius: "50%", // Makes the checkbox circular
                    border: "1px solid gray", // Adds border
                    outline: "none", // Removes focus outline
                    cursor: "pointer",
                    transition: "background-color 0.2s ease",
                  }}
                  onChange={(e) => {
                    // Dynamically toggle the background color
                    e.target.style.backgroundColor = e.target.checked
                      ? "#4caf50"
                      : "transparent";
                    e.target.style.borderColor = e.target.checked
                      ? "#4caf50"
                      : "#000";
                  }}
                />
                <span style={{ marginLeft: "8px", fontSize: "16px" }}>
                  Not Verified
                </span>
              </div>
             
            </div>
            <div style={{display: 'flex', flexDirection: 'column', paddingTop: '12px'}}>
              <label style={{fontWeight: '600'}}>Remarks related to the documentation (if any):</label>
              <textarea placeholder="Enter" style={{padding: '8px'}}></textarea>
            </div>
          </section>
        </div>
        <div style={{textAlign: 'right'}}>
        <button type="submit" className="update-button">
              Update
            </button>

        </div>
              </div>
    </div>
  );
};

export default VaccinationModal;
